import { render, staticRenderFns } from "./eddid-bank-account.vue?vue&type=template&id=d5bbd7f4&scoped=true&"
import script from "./eddid-bank-account.vue?vue&type=script&lang=js&"
export * from "./eddid-bank-account.vue?vue&type=script&lang=js&"
import style0 from "./eddid-bank-account.vue?vue&type=style&index=0&id=d5bbd7f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5bbd7f4",
  null
  
)

component.options.__file = "eddid-bank-account.vue"
export default component.exports